import { makeAutoObservable } from 'mobx'
import { type IResponseTwilioInbox, type IResponseTwilioInboxNumber } from 'entities/Call/api/types'

export class TwilioInbox {
  readonly type = 'inbox' as const

  id: number
  name: string
  is_muted: boolean
  number: IResponseTwilioInboxNumber | null

  constructor(payload: IResponseTwilioInbox) {
    this.id = payload.id
    this.name = payload.name ?? ''
    this.is_muted = payload.is_muted
    this.number = payload.number

    makeAutoObservable(this)
  }

  get isMuted(): boolean {
    return this.is_muted
  }

  get numberId(): number | null {
    return this.number?.id ?? null
  }

  handleUpdateIsMuted = (status: boolean) => {
    this.is_muted = status
  }
}
